var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elite-tabs-wrapper-content"},[_c('div',{staticClass:"custom-header"},[_c('h3',[_vm._v(_vm._s(`${_vm.importation.name}`)+" - "+_vm._s(_vm.$t("IMPORTS.RESULTS")))])]),_c('import-results',{attrs:{"importResults":_vm.importation.results}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }